import { Box, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    footer: {
        marginTop: 24,
        padding: "14px 20px",
        backgroundColor: "#2d2d2d",
        borderTop: "4px solid #fcca4a",
        textAlign: "center",
        color: "#ffffff",
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
        // Thermal / B&W printers often drop fills — use black text + borders instead
        "@media print": {
            marginTop: 16,
            padding: "10px 0",
            backgroundColor: "transparent !important",
            color: "#000000 !important",
            borderTop: "2px solid #000000",
            borderBottom: "2px solid #000000",
            "-webkit-print-color-adjust": "exact",
            printColorAdjust: "exact",
            colorAdjust: "exact",
        },
    },
    poweredBy: {
        fontSize: "0.7rem",
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        opacity: 0.85,
        marginBottom: 4,
        "@media print": {
            color: "#000000 !important",
            opacity: 1,
        },
    },
    brand: {
        fontSize: "0.95rem",
        fontWeight: 700,
        color: "#fcca4a",
        letterSpacing: "0.04em",
        "@media print": {
            color: "#000000 !important",
            fontWeight: 900,
        },
    },
    contact: {
        fontSize: "0.75rem",
        marginTop: 6,
        opacity: 0.9,
        "@media print": {
            color: "#000000 !important",
            opacity: 1,
        },
    },
}));

export function ReportFooter() {
    const classes = useStyles();

    return (
        <Box className={`report-footer ${classes.footer}`}>
            <Typography className={classes.poweredBy}>Powered by</Typography>
            <Typography className={classes.brand}>IRA TECHNOLOGIES</Typography>
            <Typography className={classes.contact}>+92 342 716 9390</Typography>
        </Box>
    );
}
